import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Image } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import ReCAPTCHA from "react-google-recaptcha";
import Backend from '../../Backend';
import Check from '../../Images/check.svg';
import CheckCorrect from '../../Images/check-correct.svg';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import NavbarEmptyComponent from '../NavbarEmpty';
import Connection from '../../Calls';
import es from '../../translate/es'
import en from '../../translate/en'

class ConfirmationForgotIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reCaptcha: '',
      showLoad: false,
      email: '',
      password: '',
      confirmPassword: '',
      token: '',
      text:en

    }
  }

  componentWillMount() {
    var email = new window.URL(window.location.href).searchParams.get("email");
    var token = new window.URL(window.location.href).searchParams.get("token");
    this.setState({
      email: email,
      token: token
    });
    this.bQk7VZx7();

    if(localStorage.getItem('lan') == 'es')this.setState({text:es})
    else this.setState({text:en})

  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {
      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  sendData() {
    const self = this;

    self.setState({ showLoad: true });
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email) !== false) {
      if (this.state.reCaptcha !== "") {
        if (this.state.email !== "" && this.state.password !== "" && this.state.confirmPassword !== "") {
          if (this.state.password === this.state.confirmPassword) {
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XWBX203"), latitude = "0", longitude = "0";
            let whiskas = Connection.RThzHrsb(self.state.confirmPassword);
            navigator.geolocation.getCurrentPosition((success, error, options) => {
              latitude = success.coords.latitude;
              longitude = success.coords.longitude
            });
            result = latitude + longitude;

            Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", whiskas, response => {
              Backend.ConfirmationForgot(self.state.email, self.state.token, response.payload.r03, self.state.reCaptcha, response => {
                if (response.status.code === "0") {
                  store.addNotification({
                    title: "Success!",
                    message: response.payload.message,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 1800,
                      onScreen: true
                    }
                  });
                  self.setState({ email: '', password: '', confirmPassword: '', reCaptcha: '', showLoad: false });
                  setTimeout(function () { self.props.data.history.push("/") }, 2000);
                } else {
                  store.addNotification({
                    title: "Error!",
                    message: response.status.description,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 1800,
                      onScreen: true
                    }
                  });
                  self.setState({ showLoad: false });
                }
              });
            });
          } else {
            store.addNotification({
              title: "Error!",
              message: "both passwords must be similar",
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({ showLoad: false });
          }
        } else {
          store.addNotification({
            title: "Error!",
            message: "Verify information, fields cannot be empty",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          self.setState({ showLoad: false });
        }
      } else {
        store.addNotification({
          title: "Error!",
          message: "Verifiy the captcha",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true
          }
        });
        self.setState({ showLoad: false });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "Email is bad formmated",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({ showLoad: false });
    }
  }

  validatePassword() {
    const self = this;

    if (self.state.password.length >= 8) {
      self.setState({ validatePass8: true });
    } else {
      self.setState({ validatePass8: false });
    }

    if (/(?:.*[A-Z]){1}/.test(this.state.password)) {
      self.setState({ validatePassMayus: true });
    } else {
      self.setState({ validatePassMayus: false });
    }

    if (/(?:.*[a-z]){1}/.test(this.state.password)) {
      self.setState({ validatePassMinus: true });
    } else {
      self.setState({ validatePassMinus: false });
    }

    if (/(?:.*\d){1}/.test(this.state.password)) {
      self.setState({ validatePassDigit: true });
    } else {
      self.setState({ validatePassDigit: false });
    }

    if (/[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\]\\]/gi.test(this.state.password)) {
      self.setState({ validatePassEspecial: true });
    } else {
      self.setState({ validatePassEspecial: false });
    }

    if (this.state.password === this.state.confirmPassword && this.state.password !== "" && this.state.confirmPassword !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }

  }

  validateConfirmPassword() {
    const self = this;
    if (this.state.confirmPassword === this.state.password && this.state.confirmPassword !== "" && this.state.password !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }
  }

  render() {
    return (
      <div>
        <NavbarEmptyComponent data={this.props} />
        <div className="contenedor-fondo-firebit">
          <Container fluid>
            <Row>
              <Col md={4} />
              <Col md={4}>
                <Container>
                  <Row className="container-signup">
                    <Col md={12}>
                      <div style={{ textAlign: "center", marginBottom: 30 }}>
                        <p className="confirmation-title">{this.state.text.Forgot.forgotPage.hi}, {this.state.email}</p>
                      </div>
                      <div>
                        <Form.Group>
                          <Form.Label className="label-signup">{this.state.text.Forgot.forgotPage.L_password}</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="********"
                            className="input-signup"
                            value={this.state.password}
                            onChange={(password) => { this.setState({ password: password.target.value }) }}
                            onKeyUp={() => { this.validatePassword() }}
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label className="label-signup">{this.state.text.Forgot.forgotPage.L_cPassword}</Form.Label>
                          <Form.Control
                            className="input-signup"
                            type="password"
                            placeholder="********"
                            value={this.state.confirmPassword}
                            onChange={(confirmPassword) => { this.setState({ confirmPassword: confirmPassword.target.value }) }}
                            onKeyUp={() => { this.validateConfirmPassword() }}
                          />
                        </Form.Group>
                        <div className="container-messages-signup">
                          <p className={!this.state.validatePass8 ? "label-validates" : "label-validates-correct"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePass8 ? Check : CheckCorrect} />
                            {this.state.text.General.PassRequirements.req1}.
                        </p>
                          <p className={!this.state.validatePassMayus ? "label-validates" : "label-validates-correct"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassMayus ? Check : CheckCorrect} />
                            {this.state.text.General.PassRequirements.req2}.
                        </p>
                          <p className={!this.state.validatePassMinus ? "label-validates" : "label-validates-correct"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassMinus ? Check : CheckCorrect} />
                            {this.state.text.General.PassRequirements.req3}.
                        </p>
                          <p className={!this.state.validatePassDigit ? "label-validates" : "label-validates-correct"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassDigit ? Check : CheckCorrect} />
                            {this.state.text.General.PassRequirements.req4}.
                        </p>
                          <p className={!this.state.validatePassEspecial ? "label-validates" : "label-validates-correct"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassEspecial ? Check : CheckCorrect} />
                            {this.state.text.General.PassRequirements.req5}.
                        </p>
                          <p className={!this.state.validatePassSame ? "label-validates" : "label-validates-correct"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassSame ? Check : CheckCorrect} />
                            {this.state.text.General.PassRequirements.req6}.
                        </p>
                        </div>
                      </div>
                      <div style={{ padding: 15, marginTop: 20 }}>
                        <center>
                          {
                            (this.state.vertice) &&
                            <ReCAPTCHA
                            theme="light"
                            sitekey={this.state.vertice}
                            onChange={this.handleChange.bind(this)}
                          />
                          }
                        </center>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div style={{ marginTop: 15, textAlign: "center" }}>
                        <Button className="signup-button" variant="primary" onClick={() => { this.sendData() }} disabled={(!this.state.reCaptcha || !this.state.email || !this.state.confirmPassword || !this.state.validatePassMayus || !this.state.validatePassMinus || !this.state.validatePassEspecial || !this.state.validatePassDigit || !this.state.validatePass8 || !this.state.validatePassSame) ? true : false}>
                          {
                            (this.state.showLoad)
                              ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showLoad} />
                              : this.state.text.Forgot.forgotPage.btn
                          }
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col md={4} />
            </Row>
          </Container>
          
        </div>
      </div>
    );
  }
} export default ConfirmationForgotIndex;